import { GridLocation } from "src/grid/GridLocation";
import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class TransposeInstruction extends Instruction<"transpose"> {
  readonly type = "transpose";

  act(context: ProgramModel) {
    context.cursorIndex = new GridLocation(
      context.cursorGridLocation.col,
      context.cursorGridLocation.row
    ).toGridIndex(context.gridDimensions);

    return { shouldAdvanceCursor: false };
  }
}
